<template>
  <div ref="data" :style="{ width: width, height: height }"></div>
</template>

<script>
import DataService from "@/api/data";
export default {
  props: {
    width: null,
    height: null,
    List: Array,
    color: String,
    xycolor: String,
    serialNumber: String,
    timeUnit: String,
    equipmentModel: String,
    date: Array,
    openTimer: Boolean,
  },
  data() {
    return {
      stable: "",
      device_rank: String,
      checked: [], //变量名称
      data: null,
      list: [], //传给后端的变量名称（英文）
      chartsData: [], //图表数据
      chartsTime: [], //图表x轴
      chartsType: [], //图表数据类型
      series: [], //每条数据的配置
      legend: [],
      AllName: [],
      status: "", //0代表默认参数，1代表修改
      timer: "",
      colorList: ["#45ea91", "#2ba0ff", "#ed593b", "#f2d750"],
    };
  },
  methods: {
    //获取趋势图数据
    getTrendChart(type) {
      // console.log(type)
      // console.log(this.openTimer)
      // if(type == false){
      //   this.openTimer = false;
      //   clearInterval(this.timer)
      // }else{
      //   this.openTimer = true;
      // }
      DataService.getTrendChart({
        list: this.list,
        serialNumber: this.serialNumber,
        user_id: this.$store.state.user_id,
        status: this.status,
        equipmentModel: this.equipmentModel,
        timeUnit: this.timeUnit,
        startTime: this.date[0],
        endTime: this.date[1],
      })
        .then((res) => {
          if (res.data != null) {
            this.chartsData = res.data.namedate;
            this.chartsType = res.data.dualYAxisTrendChartRange;
            this.chartsTime = res.data.time;
            this.series = [];
            this.legend = [];
            this.handleData();
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    //处理数据
    handleData() {
      if (this.chartsData != []) {
        this.checked = [];
        Object.keys(this.chartsData).forEach((value, key) => {
          this.legend.push(value);
          this.checked.push(value);
          if (this.chartsType[value] == "小") {
            this.series.push({
              data: JSON.parse(JSON.stringify(this.chartsData))[value],
              name: value,
              yAxisIndex: 1,
              symbol: "none",
              type: "line",
              smooth: true,
            });
          } else {
            this.series.push({
              data: JSON.parse(JSON.stringify(this.chartsData))[value],
              name: value,
              symbol: "none",
              type: "line",
              smooth: true,
              itemStyle: {
                normal: {
                  color: this.colorList[key],
                },
              },
            });
          }
        });
        this.$emit("getChecked", this.checked);
      }
      // console.log(this.series)
      this.initEcharts();
    },
    initEcharts() {
      // 新建一个promise对象
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      //然后异步执行echarts的初始化函数
      newPromise.then(() => {
        this.balancedata();
      });
    },
    //图表
    balancedata() {
      let _this = this;
      if (this.data != null && this.data != "" && this.data != undefined) {
        this.data.dispose(); //销毁
      }
      this.data = this.$echarts5.init(this.$refs.data);
      window.addEventListener("resize", function() {
        _this.data.resize();
      });
      let option = {
        animation: false,
        dataZoom: [
          {
            start: 0,
            end: 100,
            type: "inside",
          },
        ],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsTime.map(function(str) {
            return str.replace(" ", "\n");
          }),
          axisLabel: {
            show: true,
            textStyle: {
              color: this.xycolor, //更改坐标轴文字颜色
            },
          },
        },
        yAxis: [
          {
            type: "value",
            min: 0,
            max: 500,
            interval: 100,
            axisLabel: {
              show: true,
              textStyle: {
                color: this.xycolor, //更改坐标轴文字颜色
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,.1)",
              },
            },
          },
          {
            type: "value",
            min: 0,
            max: 2,
            interval: 0.4,
            axisLabel: {
              show: true,
              textStyle: {
                color: this.xycolor, //更改坐标轴文字颜色
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,.1)",
              },
            },
          },
        ],
        legend: {
          data: this.legend,
          textStyle: {
            color: this.color,
            fontSize: "12",
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(50,50,50,0.7)",
          textStyle: {
            color: "#fff",
          },
          // formatter: function (params) {
          //   console.log(params)
          // }
        },
        // dataZoom: [{
        //   type: 'inside',
        //   start: 0,
        //   end: 100
        // }, {
        //   start: 0,
        //   end: 100,
        //   bottom:"0.8%"
        // }],
        series: this.series,
      };
      this.data.setOption(option, true);
    },
    //获取默认图表参数
    defult() {
      this.AllName = [];
      DataService.queryTrendChartRequiredVariables({
        stable: this.stable,
        centrifugeLevel: this.device_rank,
      })
        .then((res) => {
          // console.log(res)
          res.data.forEach((el) => {
            if (this.list.length < 2) {
              this.list.push(Object.values(el)[0]);
            }
            this.AllName.push(el);
          });
          this.status = 0;
          this.$emit("AllNameData", this.AllName);
          this.getTrendChart();
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
  },
  created() {
    if (this.$route.query.device_rank) {
      this.device_rank = this.$route.query.device_rank;
      this.stable = this.$route.query.stable;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.defult();
    });
    let _this = this;
    // this.timer = setInterval(function(){
    //   setTimeout(() => {
    //     _this.$parent.showTime()
    //     _this.defult()
    //   }, 500);
    // }, 30000);
    if (this.openTimer == true) {
      this.timer = setInterval(function() {
        _this.$parent.time_intervalChange();
        setTimeout(() => {
          _this.defult();
        }, 500);
      }, 30000);
    } else {
      clearInterval(this.timer);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    List() {
      if (this.List == "") {
        this.list = [];
        setTimeout(() => {
          this.defult();
        }, 500);
      } else {
        this.list = this.List;
        this.status = 1;
        this.$emit("statusChange", this.status);
        this.getTrendChart();
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
